import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
});

// -----------------------------------------------------
// EXCEL ÜRETİM PROGRAMI YÜKLE
// -----------------------------------------------------
//
// Backend:
// POST /uploadUretimProgramExcel
//
// Multer:
// uploadPlanlama.single("excel")
//
export const uploadUretimProgramExcel = (
  file,
  programTarihi = "",
  replaceExisting = true
) => {
  const formData = new FormData();

  formData.append("excel", file);
  formData.append("replaceExisting", String(replaceExisting));

  // Excel başlığında tarih bulunamazsa veya tarihi elle göndermek
  // istersen bu alan backend'e iletilir.
  if (programTarihi) {
    formData.append("programTarihi", programTarihi);
  }

  return customerApi.post("/uploadUretimProgramExcel", formData, {
    headers: {
      ...getAuthHeaders(),

      // Content-Type elle yazılmıyor.
      // Axios multipart boundary bilgisini otomatik oluşturur.
    },
  });
};

// -----------------------------------------------------
// TARİH ARALIĞINDA TAKVİM VERİLERİNİ GETİR
// -----------------------------------------------------
//
// Backend:
// GET /getUretimProgramCalendar
//
// Örnek:
// getUretimProgramCalendar("2026-07-20", "2026-07-26")
//
export const getUretimProgramCalendar = (startDate, endDate) => {
  return customerApi.get(
    `/getUretimProgramCalendar/${encodeURIComponent(
      startDate
    )}/${encodeURIComponent(endDate)}`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

// -----------------------------------------------------
// TEK GÜNÜN ÜRETİM PROGRAMINI GETİR
// -----------------------------------------------------
//
// Backend:
// GET /getUretimProgramByDate/:date
//
// Örnek:
// getUretimProgramByDate("2026-07-23")
//
export const getUretimProgramByDate = (date) => {
  return customerApi.get(
    `/getUretimProgramByDate/${encodeURIComponent(date)}`,
    {
      headers: getAuthHeaders(),
    }
  );
};

// -----------------------------------------------------
// GÜNLÜK PROGRAMI PASİFE AL
// -----------------------------------------------------
//
// Backend:
// POST /deactivateUretimProgramByDate
//
// Body:
// {
//   date: "2026-07-23"
// }
//
export const deactivateUretimProgramByDate = (date) => {
  return customerApi.post(
    "/deactivateUretimProgramByDate",
    {
      date,
    },
    {
      headers: getAuthHeaders(),
    }
  );
};
